import ufeApi from 'services/api/ufeApi';
import rougeExclusiveUtils from 'utils/rougeExclusive';
import userUtils from 'utils/User';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';

const SOURCE_TYPES = {
    CHECKOUT: 'checkout',
    PROFILE: 'profile',
    SNAPSHOT: 'snapshot',
    ORDER_CONFIRMATION: 'orderConfirmation'
};

// https://confluence.sephora.com/wiki/display/ILLUMINATE/Get+BI+Rewards+Group+API
function _getBiRewardsGroup(source, config) {
    const isUserAnonymous = userUtils.isAnonymous();
    const biAccountId = userUtils.getBiAccountId() || Storage.local.getItem(LOCAL_STORAGE.USER_DATA)?.profile?.beautyInsiderAccount?.biAccountId;
    const baseUrl = '/gway/v1/lxs/rewards';
    const loyaltyIdParam = !isUserAnonymous && biAccountId ? `&loyaltyId=${biAccountId}` : '';
    const filterOutOfStock = config?.filterOutOfStock ? `&filterOutOfStock=${config.filterOutOfStock}` : '';
    const defaultSAZipCode = userUtils.getDefaultSAZipCode();
    const defaultSACountryCode = userUtils.getDefaultSACountryCode();

    const url = `${baseUrl}?source=${source}${loyaltyIdParam}${filterOutOfStock}`;

    const headers = {
        'x-requested-source': 'web',
        ...(defaultSAZipCode && { defaultSAZipCode }),
        ...(defaultSACountryCode && { defaultSACountryCode })
    };

    return ufeApi.makeRequest(url, { method: 'GET', headers }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

function getBiRewardsGroupForCheckout() {
    if (rougeExclusiveUtils.isRougeExclusiveEnabled) {
        return _getBiRewardsGroup(SOURCE_TYPES.CHECKOUT);
    }

    return _getBiRewardsGroup(SOURCE_TYPES.CHECKOUT);
}

function getBiRewardsGroupForProfile(config) {
    if (rougeExclusiveUtils.isRougeExclusiveEnabled) {
        return _getBiRewardsGroup(SOURCE_TYPES.PROFILE, config);
    }

    return _getBiRewardsGroup(SOURCE_TYPES.PROFILE, config);
}

function getBiRewardsGroupForSnapshot() {
    return _getBiRewardsGroup(SOURCE_TYPES.SNAPSHOT);
}

function getBiRewardsGroupForOrderConf() {
    return _getBiRewardsGroup(SOURCE_TYPES.ORDER_CONFIRMATION);
}

export default {
    getBiRewardsGroupForCheckout,
    getBiRewardsGroupForProfile,
    getBiRewardsGroupForSnapshot,
    getBiRewardsGroupForOrderConf
};
